import React from 'react';
import StyledComponent from '~/components/Styled/Styled';
import compact from 'lodash/compact';
import flatten from 'lodash/flatten';
import replace from 'lodash/replace';
import { injectIntl } from 'react-intl';
import messages from '~/constants/localizations/timeline';
import zip from 'lodash/zip';
import TimelineEntry from './TimelineEntry/TimelineEntry';
import css from './Timeline.scss';

interface State {
  teams: any;
  shootouts: TimelineEvent[];
}

type Props = {
  event: Event;
  timeline: TimelineEvent[];
  shootouts: TimelineEvent[];
  intl: any;
};

class Timeline extends React.Component<Props, State> {
  static displayName: string;

  constructor(props) {
    super(props);

    const events = this.props.timeline || this.props.shootouts;

    const teams = { home: props.event.home_team, away: props.event.away_team };
    let shootouts = [];

    if (this.props.shootouts) {
      shootouts = this.sortShootouts(events, teams);
    }

    this.state = {
      shootouts,
      teams,
    };
  }

  sortShootouts(events: TimelineEvent[], teams) {
    if (!teams.home || !teams.away) {
      return [];
    }

    const teamAwayShootouts = events.filter(event => event.team.id === teams.away.id);
    const teamHomeShootouts = events.filter(event => event.team.id === teams.home.id);
    const shootouts = compact(flatten(zip(teamHomeShootouts, teamAwayShootouts)));

    return shootouts;
  }

  renderHeader() {
    return (
      <div className={css.header}>
        {this.state.teams.home && (
          <div className={css.teamHome}>{this.state.teams.home.abbreviation}</div>
        )}
        {this.state.teams.away && (
          <div className={css.teamAway}>{this.state.teams.away.abbreviation}</div>
        )}
      </div>
    );
  }

  render() {
    const { timeline, shootouts, intl: { formatMessage } } = this.props;
    return (
      <div className={css.container}>
        {timeline && (
          <span>
            <div className={css.title}>{formatMessage(messages.title)}</div>
            {this.renderHeader()}
            {timeline.map(event => {
              const isSegment = event.type === 'action_segment_end';

              if (isSegment) {
                const message =
                  messages[`segment_${replace(event.description, ' ', '_').toLowerCase()}`];

                return (
                  <span>
                    <div className={css.segment}>
                      <img alt="soccer whistle" src={'/static/images/soccer/whistle.png'} />
                      <div className={css.label}>{formatMessage(message).toUpperCase()}</div>
                    </div>
                  </span>
                );
              }
              return (
                <TimelineEntry
                  teams={this.state.teams}
                  timelineEvent={event}
                  away={event.team && event.team.id !== this.state.teams.away.id}
                />
              );
            })}
          </span>
        )}
        {shootouts && (
          <span>
            <div className={css.title}>{formatMessage(messages.title_penalties)}</div>
            {this.renderHeader()}
            {this.state.shootouts.map((event, index) => (
              <span>{event && <TimelineEntry timelineEvent={event} away={index % 2 !== 1} />}</span>
            ))}
          </span>
        )}
      </div>
    );
  }
}

Timeline.displayName = 'Timeline';

export default injectIntl(StyledComponent(Timeline, [css]));
